/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { PrinterOutlined } from "@ant-design/icons";
import { BaseKey, GetOneResponse, useNotification } from "@refinedev/core";
import { QueryObserverResult } from "@tanstack/react-query";
import {
  Badge,
  Button,
  Col,
  Form,
  FormProps,
  Input,
  InputNumber,
  Modal,
  ModalProps,
  Row,
  Typography,
} from "antd";
import { useCallback, useEffect, useState } from "react";

import {
  useChangeStatusWithdrawal,
  useGetDetailWithdrawal,
} from "../../api/wallet";
import PaymentStatus from "../../types/paymentStatus.type";
// import { dateOfTransactionRules } from "../../utils/form.constants";
import { useIsAdminRole } from "../../utils/hooks/useIdentityAdmin.hook";
import {
  paymentStatusColors,
  paymentStatusNames,
} from "../../utils/paymentStatus.utils";
import { DefaultDatePicker, getDateValueProps } from "../components/datePicker";
import { PaymentRequestsEditForm } from "../components/interface";
import { dateOfTransactionFieldStyle, inputFormStyles } from "../styles/style";

interface IProps {
  formProps: FormProps;
  modalProps: ModalProps;
  queryResult?: QueryObserverResult<GetOneResponse<PaymentRequestsEditForm>>;
  id?: BaseKey;
  resetEditingId: () => void;
  formIsLoading: boolean;
  close: () => void;
  refetchWithdrawal: any;
}

export const PaymentRequestEdit = ({
  modalProps,
  formProps,
  queryResult,
  id,
  resetEditingId,
  close,
  refetchWithdrawal,
}: IProps) => {
  const { open: openNotification } = useNotification();
  const isAdminRole = useIsAdminRole();
  const [statusChange, setStatusChange] = useState<any>();
  const [invalidFund, setInvalidFund] = useState<any>("");

  const { data } = useGetDetailWithdrawal(id || 0);

  const { mutate, isLoading } = useChangeStatusWithdrawal({
    onSuccess: (response: { data: { message: string } }) => {
      if (openNotification) {
        openNotification({
          key: "success_transaction_confirm",
          message: response?.data?.message || "Change status successfully!",
          type: "success",
        });
      }
      refetchWithdrawal();
      setStatusChange(null);
      close();
      setInvalidFund("");
    },
    onError: (error: { message: string; reason_code: string }) => {
      console.log("error", error);
      if (error?.reason_code === "ERR00109") {
        setInvalidFund(error?.message);
      } else {
        if (openNotification) {
          openNotification({
            key: "error",
            message: error?.message || "Change status failed!",
            type: "error",
          });
        }
        resetEditingId();
        refetchWithdrawal();
        close();
        queryResult?.remove();
      }
      setStatusChange(null);
    },
  });

  useEffect(() => {
    if (!data) return;
    formProps?.form?.setFieldsValue({
      transferMode:
        data?.data?.data?.withdrawMethod === "SMART_USER"
          ? "SMART UID"
          : "Crypto Network",
      customer: data?.data?.data?.senderUser?.email,
      dateOfTransaction: data?.data?.data?.createdAt,
      amount: data?.data?.data?.amount,
      fee: data?.data?.data?.fee,
      receiveAmount: data?.data?.data?.receiveAmount,
      chainType: data?.data?.data?.network
        ? data?.data?.data?.network?.name
        : undefined,
      currency: data?.data?.data?.currency?.symbol,
      note: data?.data?.data?.note,
      reason: data?.data?.data?.reason,
      beneficiary: data?.data?.data?.recipientUser
        ? data?.data?.data?.recipientUser?.email
        : undefined,
      wallet:
        data?.data?.data?.withdrawAddress || data?.data?.data?.recipientEmail,
    });
  }, [data, statusChange]);

  const onClose = useCallback(() => {
    setInvalidFund("");
    close();
  }, [close]);

  const afterClose = useCallback(() => {
    resetEditingId();
    queryResult?.remove();
  }, [queryResult, resetEditingId]);

  const handleChangeStatus = () => {
    mutate({ id: id || 0, status: statusChange });
  };

  const handleCancel = () => {
    if (isLoading) return;
    setStatusChange(null);
  };

  return (
    <>
      <Modal
        {...modalProps}
        className="smartModalTitle"
        title={`Detail`}
        destroyOnClose
        maskClosable={false}
        footer={
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ color: "red" }}>{invalidFund}</div>
            <Row
              style={{
                justifyContent: "space-around",
                justifyItems: "center",
                width: "400px",
              }}
            >
              <Button
                key="reject"
                type={isAdminRole ? "primary" : undefined}
                onClick={() => setStatusChange("REJECTED")}
                loading={false}
                className="ant-btn-rejected"
                disabled={!(data?.data?.data?.status === PaymentStatus.PENDING)}
              >
                Reject
              </Button>
              <Button
                key="approve"
                type={isAdminRole ? "primary" : undefined}
                onClick={() => setStatusChange("APPROVED")}
                loading={false}
                disabled={!(data?.data?.data?.status === PaymentStatus.PENDING)}
              >
                Approve
              </Button>
            </Row>
            {data?.data?.data?.printableFormUrl && (
              <Button
                icon={<PrinterOutlined />}
                type={"link"}
                href={data?.data?.data?.printableFormUrl}
                target={"_blank"}
              >
                &nbsp;Print
              </Button>
            )}
          </Col>
        }
        onCancel={onClose}
        afterClose={afterClose}
      >
        <Form
          {...formProps}
          validateTrigger={false}
          className="detail-withdraw"
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography style={{ fontSize: "16px", fontWeight: 600 }}>
              Order {data?.data?.data?.walletOrder?.[0].orderId}
            </Typography>
            <Badge
              color={paymentStatusColors[data?.data?.data?.status]}
              text={paymentStatusNames[data?.data?.data?.status]}
            />
          </div>
          <Col
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Form.Item label="Amount" name="amount" style={{ width: "48%" }}>
              <InputNumber
                placeholder="Withdrawal amount"
                disabled
                controls={false}
                style={inputFormStyles}
              />
            </Form.Item>
            <Form.Item
              label="Currency"
              name="currency"
              style={{ width: "48%", marginTop: 5 }}
            >
              <Input placeholder="Currency" disabled style={inputFormStyles} />
            </Form.Item>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Form.Item label="Fees" name="fee" style={{ width: "48%" }}>
              <InputNumber
                placeholder="Fees"
                disabled
                controls={false}
                style={inputFormStyles}
              />
            </Form.Item>
            <Form.Item
              label="Received"
              name="receiveAmount"
              style={{ width: "48%" }}
            >
              <InputNumber
                placeholder="Received amount"
                disabled
                controls={false}
                style={inputFormStyles}
              />
            </Form.Item>
          </Col>
          {data?.data?.data?.withdrawMethod === "SMART_USER" ? (
            <Form.Item label="Transfer Method" name="transferMode">
              <Input
                placeholder="Transfer Method"
                disabled
                style={inputFormStyles}
              />
            </Form.Item>
          ) : (
            <Col
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Form.Item
                label="Transfer Method"
                name="transferMode"
                style={{ width: "48%" }}
              >
                <Input
                  placeholder="Transfer Method"
                  disabled
                  style={inputFormStyles}
                />
              </Form.Item>
              <Form.Item
                label="Chain Type"
                name="chainType"
                style={{ width: "48%" }}
              >
                <Input
                  placeholder="Chain Type"
                  disabled
                  style={inputFormStyles}
                />
              </Form.Item>
            </Col>
          )}
          <Form.Item label="Remitter" name="customer">
            <Input placeholder="Customer" disabled style={inputFormStyles} />
          </Form.Item>
          {data?.data?.data?.withdrawMethod === "SMART_USER" ? (
            <Form.Item label="Beneficiary" name="beneficiary">
              <Input
                placeholder="Beneficiary"
                disabled
                style={inputFormStyles}
              />
            </Form.Item>
          ) : (
            <Form.Item label="Address" name="wallet">
              <Input placeholder="Address" disabled style={inputFormStyles} />
            </Form.Item>
          )}

          <Form.Item
            label="Date"
            name="dateOfTransaction"
            getValueProps={getDateValueProps}
          >
            <DefaultDatePicker
              placeholder="Date of withdrawal"
              style={dateOfTransactionFieldStyle}
              disabled
            />
          </Form.Item>
          {data?.data?.data?.status === PaymentStatus.FAILED ? (
            <Form.Item label="Reason" name="reason">
              <Input placeholder="Reason" disabled style={inputFormStyles} />
            </Form.Item>
          ) : null}
          <Form.Item label="Note" name="note">
            <Input.TextArea
              minLength={2}
              placeholder="Note"
              disabled
              style={inputFormStyles}
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        key={"Confirm"}
        open={statusChange}
        className="smartModalTitle"
        title={`Confirm`}
        destroyOnClose
        maskClosable={false}
        footer={
          <Col>
            <Row
              style={{
                justifyContent: "space-around",
                justifyItems: "center",
                width: "400px",
              }}
            >
              <Button
                key="cancel"
                type={undefined}
                onClick={handleCancel}
                loading={isLoading}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                key="confirm"
                type={"primary"}
                onClick={handleChangeStatus}
                loading={isLoading}
                disabled={isLoading}
              >
                Confirm
              </Button>
            </Row>
          </Col>
        }
        onCancel={handleCancel}
      >
        <div>
          <Typography>
            Do you want to{" "}
            {statusChange === PaymentStatus.REJECTED ? "rejecte" : "complete"}{" "}
            this withdrawal?
          </Typography>
        </div>
      </Modal>
    </>
  );
};
